import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '..';

export const selectSelf = (state: RootState) => state.newSongs;

export const selectSong = (songId: string) =>
  createSelector(
    selectSelf,
    (newSongs) => newSongs.songs[songId]?.data ?? null
  );
